import { createChecklistHelpers } from '../utils/checklist-helper'

const {
  actionAddList,
  actionCheck,
  actionUncheck,
  selectRaw,
  select,
  selectLabels,
} = createChecklistHelpers('preOpChecklist', 'precheck')

/**
 * @param {string[]} listOfStrings
 * @returns {any} Updates to apply to case
 */
export const actionAddPreOpChecks = actionAddList

/**
 * @param {string} id
 * @returns {any} Updates to apply to case
 */
export const actionCheckPreOpCheck = actionCheck

/**
 * @param {string} id
 * @returns {any} Updates to apply to case
 */
export const actionUncheckPreOpCheck = actionUncheck

/**
 * @param {any} caseData
 * @returns {{
 *   [id: string]: {
 *     label: string
 *     order: number
 *     complete: boolean
 *   }
 * }}
 */
export const selectPreOpChecksRaw = selectRaw

/**
 * @param {any} caseData
 * @returns {Checklist}
 */
export const selectPreOpChecks = select

/**
 * @param {any} caseData
 * @returns {string[]}
 */
export const selectPreOpCheckLabels = selectLabels
